<script setup lang="ts">
defineProps<{
  email: string
}>()
</script>

<template>
  <a :href="`mailto:${email}`" class="hyperlink">{{ email }}</a>
</template>
